/* Lightweight parallax engine for .parallax-section
   - Works inside clipped containers (overflow hidden)
   - Keeps image covering 100% of section (CSS background-size: cover)
   - Uses translateY via CSS var --parallax-y and a small scale to avoid edges
   - Respects prefers-reduced-motion
*/
(function () {
  if (window.__parallaxInit) return; // guard against multiple inclusions
  window.__parallaxInit = true;

  var reduceMotion = false;
  try {
    var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    reduceMotion = mql && mql.matches;
    if (mql && typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', function (e) { reduceMotion = e.matches; });
    }
  } catch (e) {}

  var sections = Array.prototype.slice.call(document.querySelectorAll('.parallax-section'));
  if (!sections.length) return;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getBgEl(section) {
    // Prefer the visible background layer (desktop or mobile)
    var desktop = section.querySelector('.parallax-section__bg--desktop');
    var mobile = section.querySelector('.parallax-section__bg--mobile');
    if (desktop && window.getComputedStyle(desktop).display !== 'none') return desktop;
    if (mobile && window.getComputedStyle(mobile).display !== 'none') return mobile;
    // Fallback to any bg
    return desktop || mobile || section.querySelector('.parallax-section__bg');
  }

  var active = new Set();

  var io;
  try {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          active.add(el);
        } else {
          active.delete(el);
          // Reset shift when offscreen
          var bg = getBgEl(el);
          if (bg) bg.style.setProperty('--parallax-y', '0px');
        }
      });
      requestTick();
    }, { root: null, threshold: [0, 0.5, 1] });
  } catch (e) {}

  sections.forEach(function (section) {
    if (io) io.observe(section); else active.add(section);
  });

  var ticking = false;
  function requestTick() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateAll);
    }
  }

  function updateAll() {
    ticking = false;
    if (reduceMotion) {
      // Ensure no transform is applied when reduced motion is preferred
      active.forEach(function (sec) {
        var bg = getBgEl(sec);
        if (bg) bg.style.setProperty('--parallax-y', '0px');
      });
      return;
    }

    var vpH = window.innerHeight || document.documentElement.clientHeight;
    var vpCenter = vpH / 2;
    var mobile = isMobile();

    active.forEach(function (sec) {
      var enableMobile = String(sec.getAttribute('data-enable-mobile')).toLowerCase() === 'true';
      if (mobile && !enableMobile) {
        var bg0 = getBgEl(sec);
        if (bg0) bg0.style.setProperty('--parallax-y', '0px');
        return;
      }

      var rect = sec.getBoundingClientRect();
      // Compute distance of section center from viewport center
      var secCenter = rect.top + rect.height / 2;
      var delta = secCenter - vpCenter; // px
      var speed = parseFloat(sec.getAttribute('data-parallax-speed') || '0.15');
      // Limit shift to avoid edges (scale already ~1.12)
      var maxShift = rect.height * 0.08; // 8% of section height
      var shift = -delta * speed;
      if (shift > maxShift) shift = maxShift;
      else if (shift < -maxShift) shift = -maxShift;

      var bg = getBgEl(sec);
      if (bg) bg.style.setProperty('--parallax-y', shift.toFixed(2) + 'px');
    });
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
  window.addEventListener('orientationchange', requestTick, { passive: true });

  // Initial run
  requestTick();
})();
